/**
 * **분석 코드 표시 정본** — 코드 목록·색이 다섯 컴포넌트에 사본으로 살았고
 * 색까지 서로 발산했다(Modelica #2e7d32/#009688 혼재, GAMMA+ 개명이 4파일
 * 수술 — 전수 사냥 B4). 존재·색·칩 배경은 여기 한 곳이 정하고, 지원 여부는
 * 저작 코드 선언 participantCodes(isAnalysisCodeSupported)가 정한다(레지스트리 participantKinds 는 그 선언을 참조로 붙인다).
 */
import type { AnalysisCode } from '@/types/project';

export interface AnalysisCodeStyle {
  /** 칩·강조 색 */
  color: string;
  /** 밝은 배경(정보 카드) */
  bg: string;
  /** 밝은 배경 위 글자색 */
  fg: string;
}

export const ANALYSIS_CODE_STYLES: Record<AnalysisCode, AnalysisCodeStyle> = {
  MARS: { color: '#1976d2', bg: '#e3f2fd', fg: '#1565c0' },
  'GAMMA+': { color: '#9c27b0', bg: '#f3e5f5', fg: '#7b1fa2' },
  Modelica: { color: '#009688', bg: '#e8f5e9', fg: '#2e7d32' },
};


export const analysisCodeColor = (code: string): string | undefined =>
  (ANALYSIS_CODE_STYLES as Record<string, AnalysisCodeStyle>)[code]?.color;
